export default {"src":"/login-app/[GIT_HASH]/_next/static/media/arrow_indent.9e39ace0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};